(function () {
    'use strict';
    /* global _, $q */

    angular
        .module('surveyControllers')
        .controller('SurveyQuestionRankingController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {

        // Views
        $scope.view = {};

        // Model Init
        if (_.isUndefined($scope.question.Responses)) {
            $scope.question.Responses = [{ QuestionID: $scope.question.CampaignComponentID }];
        } else if ($scope.question.Responses.length > 1) {
            $scope.showTooManyResponsesErrorAlert();
        }
        $scope.questionResponse = $scope.question.Responses[0];
        initRankings();

        // Update RersponseValues
        $scope.updateResponseValues = function () {
            $scope.toAddResponse()($scope.question, $scope.questionResponse)
                .then(function (updatedResponse) {
                    $scope.questionResponse = _.assign(updatedResponse);
                });
        };

        // Is ranking selected ?
        $scope.isRankingSelected = function (ranking) {
            if (_.isUndefined($scope.questionResponse.ResponseValue)) return false;

            return $scope.questionResponse.ResponseValue === ranking;
        };

        // Select Ranking
        $scope.selectRanking = function (ranking) {
            if ($scope.questionResponse.ResponseValue === ranking) return;

            var foundQstWithRanking = _.find($scope.groupedQuestions, function (qst) {
                if (_.size(qst.Responses) === 0) return false;

                return qst.Responses[0].ResponseValue === ranking;
            });

            if (!foundQstWithRanking) {
                return saveRanking();
            }

            delete foundQstWithRanking.Responses[0].ResponseValue;
            return $scope.toAddResponse()(foundQstWithRanking, foundQstWithRanking.Responses[0])
                         .then(saveRanking);

            function saveRanking() {
                $scope.questionResponse.ResponseValue = ranking;

                return $scope.toAddResponse()($scope.question, $scope.questionResponse)
                             .then(function (updatedResponse) {
                                 _.assign($scope.questionResponse, updatedResponse);
                             });
            }
        };

        // Helpers
        function initRankings() {

            var questionIdx = _.findIndex($scope.questions, { QuestionID: $scope.question.QuestionID });

            var questionsBefore = _.slice($scope.questions, 0, questionIdx + 1);
            var firstQuestionBeforeWithTitle = _.findLast(questionsBefore, { QuestionTypeCategoryID: 11 }); // Ranking, Title
            var firstQuestionIdx = _.findIndex($scope.questions, { QuestionID: firstQuestionBeforeWithTitle.QuestionID });

            var questionsAfter = _.slice($scope.questions, questionIdx + 1);
            var firstQuestionAfterNotWithoutTitle = _.find(questionsAfter, function (qst) {
                return qst.QuestionTypeCategoryID !== 12; // Ranking, No Title
            });
            var lastQuestionIdx = $scope.questions.length;
            if (firstQuestionAfterNotWithoutTitle) {
                lastQuestionIdx = _.findIndex($scope.questions, {
                    QuestionID: firstQuestionAfterNotWithoutTitle.QuestionID
                });
            }

            $scope.groupedQuestions = _.slice($scope.questions, firstQuestionIdx, lastQuestionIdx);
            $scope.rankings = _.map($scope.groupedQuestions, function (qst, idx) {
                return idx + 1 +'';
            });
        }
    }
})();